import * as React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import authService from '../api-authorization/AuthorizeService';
import CircularProgress from '@mui/material/CircularProgress';

interface ICampaignTypeProps {
    campaignTypeId: number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

class CampaignType {
    id: number = 0;
    type: string = '';
}

export default function CampaignTypeDropdown(props: ICampaignTypeProps) {
    const [typeList, setList] = React.useState<CampaignType[]>([]);
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        setLoaded(false);
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();

        const response = await fetch('Campaign/GetCampaignTypes', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setList(data.value);
        setLoaded(true);
    }

    const items = typeList.map((item, index) =>
        <MenuItem key={index} value={item.id}>{item.type}</MenuItem>);

    return (
        <TextField
            select
            label="Campaign Type"
            name="campaignTypeId"
            variant="outlined"
            fullWidth
            onChange={props.onChange}
            value={items.length <= 0 || props.campaignTypeId === 0 ? '' : props.campaignTypeId}
            InputProps={{
                disabled: !loaded,
                startAdornment: (
                    <React.Fragment>
                        {loaded ? null : <CircularProgress size={20} />}
                    </React.Fragment>
                )
            }}
        >
            {items}
        </TextField>
    );
}